import SortButtonBase from "./sortButton";
import SortSpan from "./sortImage";

export const SortButton = ({ direction, id, onClick, sortby }) => {
  const arrows = {
    ascending: "sorting-ascending",
    descending: "sorting-descending",
  };
  const arrow = sortby === id ? arrows[direction] : "↕︎";
  return (
    <SortButtonBase className={arrow} id={id} onClick={onClick}>
      <SortSpan>Sort {direction}</SortSpan>
    </SortButtonBase>
  );
};
